import axios from 'axios'
import store from '../../store/index'

const state = {
}

const mutations = {
}

const actions = {
  codeBySpot ({ commit }, codeIdentifier) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/customer/spot?spotCode=' + codeIdentifier,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  codeByIdentifier ({ commit }, identifier) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/customer/identifier?identifier=' + identifier,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
